var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDownloadIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.775 9.167h-3.3V4.4h-4.95v4.767h-3.3L11 15.522l5.775-6.355ZM4.4 17.11h13.2V18.7H4.4V17.11Z",
  fill: "#fff",
  fillOpacity: 0.8
})));
export { SvgDownloadIcon as ReactComponent };
export default __webpack_public_path__ + "6af4ef32e412666386996cda2e494954.svg";